export type Language = "sv" | "en";

export const LANGUAGES: Language[] = ["sv", "en"];

export const DEFAULT_LANGUAGE: Language = "sv";

export const LANGUAGE_NAMES: Record<Language, string> = {
  sv: "Svenska",
  en: "English",
};

export type TranslationKey =
  | "site.tagline"
  | "site.compareCasinos"
  | "nav.home"
  | "nav.casinos"
  | "nav.licensed"
  | "nav.unlicensed"
  | "nav.utanSpelpaus"
  | "nav.bonuses"
  | "nav.payments"
  | "nav.slots"
  | "nav.providers"
  | "nav.guides"
  | "nav.betting"
  | "nav.responsible"
  | "nav.reviews"
  | "nav.search"
  | "nav.menu"
  | "nav.close"
  | "cta.visitCasino"
  | "cta.readReview"
  | "cta.seeAll"
  | "cta.compareNow"
  | "cta.filter"
  | "cta.clear"
  | "rating.overall"
  | "rating.safety"
  | "rating.bonus"
  | "rating.payments"
  | "rating.games"
  | "rating.mobile"
  | "rating.support"
  | "label.swedishLicense"
  | "label.noSwedishLicense"
  | "label.spelpausConnected"
  | "label.notSpelpaus"
  | "label.bankid"
  | "label.swish"
  | "label.trustly"
  | "label.zimpler"
  | "label.brite"
  | "label.crypto"
  | "label.unknown"
  | "label.notVerified"
  | "label.priorityBrand"
  | "label.lastUpdated"
  | "label.minDeposit"
  | "label.withdrawalSpeed"
  | "label.bonusUpTo"
  | "label.freeSpins"
  | "label.wagering"
  | "responsible.notice"
  | "affiliate.disclosure"
  | "languageSwitcher.label"
  | "footer.about"
  | "footer.contact"
  | "footer.terms"
  | "footer.privacy"
  | "footer.copyright"
  | "footer.affiliate"
  | "homepage.heroTitle"
  | "homepage.heroSubtitle"
  | "homepage.tab.licensed"
  | "homepage.tab.unlicensed"
  | "homepage.tab.swish"
  | "homepage.tab.bonus"
  | "homepage.tab.new"
  | "homepage.popularGuides"
  | "homepage.latestReviews"
  | "homepage.topPayments"
  | "homepage.topProviders"
  | "homepage.allCasinos"
  | "search.placeholder"
  | "filters.title"
  | "list.empty"
  | "review.aboutCasino"
  | "review.bonusInfo"
  | "review.paymentMethods"
  | "review.gameProviders"
  | "review.prosAndCons"
  | "review.pros"
  | "review.cons"
  | "review.faq"
  | "warning.unlicensed"
  | "warning.utanSpelpaus";
